import { ExclamationCircleFilled } from "@ant-design/icons";

export function ErrorIcon() {
  return <ExclamationCircleFilled style={{ color: "red" }} />;
}
